// extracted by mini-css-extract-plugin
export default {"title":"styles__title___BrHRi","subtitle":"styles__subtitle___dtM4i","previewer":"styles__previewer___JZ6Wa"};